export default __webpack_public_path__ + "static/media/be_compassionate.f3483406.png";